export const TOKEN_INVALID_ERROR_CODE_REGEX = /^(\d{2})-100-0008-(\d{3})$/;
export const TOKEN_AMOUNT_EXCEED = '20-100-0008-010';



// WEBPACK FOOTER //
// ./app/constants/errorCode.js